<div class="layout-submenu-content" (click)="onClick($event)">
  <p-scrollPanel #scroller [style]="{height: '100%'}">
    <ng-content></ng-content>
  </p-scrollPanel>
</div>
